import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/header.css';

interface NavItem {
  to: string;
  label: string;
  external?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: '首页' },
  { to: '/solutions', label: '解决方案' },
  { to: '/market', label: '市场行情' },
  { to: '/trace', label: '溯源查询' },
  { to: 'https://trade.yunniuji.com', label: '交易市场', external: true },
  { to: 'https://transport.yunniuji.com', label: '监管平台', external: true },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src="/logo.svg" onError={(e) => { (e.target as HTMLImageElement).src = "/logo.png"; }} alt="" className="brand-mark" />
          <span className="brand-text">
            <strong>云牛集</strong>
            <small>山东牛产业智慧平台</small>
          </span>
        </Link>

        <button
          type="button"
          className={`nav-toggle${menuOpen ? ' is-open' : ''}`}
          aria-label={menuOpen ? '关闭导航' : '打开导航'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`site-nav${menuOpen ? ' is-open' : ''}`}>
          {NAV_ITEMS.map((item) =>
            item.external ? (
              <a
                key={item.to}
                className="nav-link"
                href={item.to}
                target="_blank"
                rel="noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  isActive ? 'nav-link active' : 'nav-link'
                }
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
